__turbopack_context__.v({
  "card": "FeaturedCard-module-scss-module__PyfRpq__card",
  "content": "FeaturedCard-module-scss-module__PyfRpq__content",
  "excerpt": "FeaturedCard-module-scss-module__PyfRpq__excerpt",
  "fade-in": "FeaturedCard-module-scss-module__PyfRpq__fade-in",
  "heading": "FeaturedCard-module-scss-module__PyfRpq__heading",
  "image": "FeaturedCard-module-scss-module__PyfRpq__image",
  "label": "FeaturedCard-module-scss-module__PyfRpq__label",
  "no-transform": "FeaturedCard-module-scss-module__PyfRpq__no-transform",
  "rotate": "FeaturedCard-module-scss-module__PyfRpq__rotate",
});
